// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"da6c8fb1","453":"08ca1245","667":"daeea698","977":"1c74eb9d"}[chunkId] + ".chunk.js";
};